import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    >
        {children}
    </motion.div>
);

export const SectionHeading = ({ overline, title, sub }) => (
    <div className="mb-14">
        <Reveal>
            <p className="font-mono2 text-xs font-bold uppercase tracking-[0.3em] text-emerald-400">{overline}</p>
        </Reveal>
        <Reveal delay={0.1}>
            <h2 className="font-spooky mt-3 text-4xl text-orange-400 text-glow-orange sm:text-5xl lg:text-6xl">{title}</h2>
        </Reveal>
        {sub && (
            <Reveal delay={0.2}>
                <p className="font-heading mt-3 text-sm uppercase tracking-[0.2em] text-slate-400">{sub}</p>
            </Reveal>
        )}
    </div>
);
